export var ASSIGNMENT_REPOSITORY_WEB_CONFIG = ' ASSIGNMENT_REPOSITORY_WEB_CONFIG';